import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';

interface ChatLoadingScreenProps {
  message?: string;
  subMessage?: string;
}
export default function ChatLoadingScreen({
  message = 'Getting things ready',
  subMessage = 'This will only take a moment',
}: ChatLoadingScreenProps) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100dvh',
        width: '100vw',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LoadingOverlay
        isOpen
        isLoading
        ariaLoadingLabel={message}
        loadingTitle={message}
        loadingMessage={subMessage}
        css={{ height: '100%', width: '100%' }}
      />
    </div>
  );
}
